import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Building2 } from "lucide-react";

export default function InviteAccept() {
  const { token } = useParams();
  const [info, setInfo] = useState(undefined); // undefined=loading, null=invalid
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.get(`/invites/${token}`).then(({ data }) => setInfo(data)).catch(() => setInfo(null)); }, [token]);

  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/invites/${token}/accept`, { name: name.trim(), password });
      localStorage.setItem("hs_token", data.token);
      toast.success("Welcome to the team!");
      window.location.href = "/recruiter";
    } catch (e) { toast.error(e.response?.data?.detail || "Could not accept invite"); setBusy(false); }
  };

  return (
    <div className="dark min-h-screen flex items-center justify-center px-4 bg-background text-foreground" data-testid="invite-accept-page">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 space-y-6">
        {info === undefined ? (
          <div className="flex items-center gap-2 text-muted-foreground py-8 justify-center"><Loader2 className="h-4 w-4 animate-spin" /> Loading invitation…</div>
        ) : info === null ? (
          <div className="text-center space-y-3" data-testid="invite-invalid"><h1 className="text-xl font-display font-bold">Invitation not found</h1><p className="text-sm text-muted-foreground">This invite is invalid or has already been used.</p><Link to="/login" className="text-primary text-sm">Go to sign in</Link></div>
        ) : (
          <>
            <div className="space-y-2 text-center">
              <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-primary/30 to-indigo-500/30 flex items-center justify-center mx-auto"><Building2 className="h-6 w-6 text-primary" /></div>
              <h1 className="text-2xl font-display font-bold tracking-tight">Join {info.org_name}</h1>
              <p className="text-sm text-muted-foreground">{info.invited_by} invited <span className="text-foreground">{info.email}</span> to hire together on HireStream.</p>
            </div>
            <div className="space-y-3">
              <div className="space-y-1.5"><Label>Your name</Label><Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Alex Rivera" data-testid="invite-name" /></div>
              <div className="space-y-1.5"><Label>Create a password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" data-testid="invite-password" /></div>
              <Button onClick={accept} disabled={busy || !name.trim() || password.length < 8} className="w-full" data-testid="invite-accept-btn">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accept & join"}</Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
